export default "__VITE_ASSET__BjAlX7IE__"